import React, { useState } from "react";
import ReactDOM from "react-dom";
import { KpiIcon } from "../../Quantative/component/KpiIcons";

/* note is stored as string or nested array ([["..."]]) — flatten to trimmed text */
export const noteToText = (note) => {
    if (!note) return "";
    const s = Array.isArray(note) ? note.flat().join("\n") : String(note);
    return s.trim();
};

/**
 * "View Note" button + portal modal with the full note text.
 * Renders nothing when the note is empty, so callers can drop it in
 * unconditionally.
 */
const ViewNoteButton = ({ note }) => {
    const [open, setOpen] = useState(false);
    const text = noteToText(note);
    if (!text) return null;

    return (
        <>
            <button
                className="kpi-action-btn kpi-btn-history"
                onClick={(e) => { e.stopPropagation(); setOpen(true); }}
            >
                <KpiIcon name="note" size={11} /> View Note
            </button>
            {open && ReactDOM.createPortal(
                <div
                    onClick={(e) => { e.stopPropagation(); setOpen(false); }}
                    style={{
                        position: "fixed", inset: 0, zIndex: 11000,
                        background: "rgba(15,23,42,0.45)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        padding: 20,
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: "#fff", borderRadius: 12,
                            width: "100%", maxWidth: 560, maxHeight: "70vh",
                            display: "flex", flexDirection: "column",
                            boxShadow: "0 20px 50px rgba(15,23,42,0.25)",
                        }}
                    >
                        <div style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            padding: "14px 18px", borderBottom: "1px solid #e8edf7",
                        }}>
                            <span style={{
                                display: "inline-flex", alignItems: "center", gap: 6,
                                fontSize: 11, fontWeight: 700, color: "#3346c2",
                                textTransform: "uppercase", letterSpacing: "0.08em",
                                fontFamily: "'JetBrains Mono','Fira Mono',monospace",
                            }}>
                                <KpiIcon name="note" size={12} color="#3346c2" /> Note
                            </span>
                            <button
                                onClick={() => setOpen(false)}
                                style={{
                                    border: "none", background: "transparent", cursor: "pointer",
                                    fontSize: 18, lineHeight: 1, color: "#5b6b8c", padding: 4,
                                }}
                                title="Close"
                            >
                                ×
                            </button>
                        </div>
                        <div style={{
                            padding: "16px 18px", overflowY: "auto",
                            fontSize: 13, color: "#1e293b", lineHeight: 1.65,
                            whiteSpace: "pre-wrap", wordBreak: "break-word",
                        }}>
                            {text}
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default ViewNoteButton;
